import React, { useState, useEffect } from 'react';
import { Lightbulb } from 'lucide-react';

const QUOTES = [
  "El arte de enseñar es el arte de asistir el descubrimiento. - Mark Van Doren",
  "Dime y lo olvido, enséñame y lo recuerdo, involúcrame y lo aprendo. - Benjamin Franklin",
  "La educación no es preparación para la vida; la educación es la vida misma. - John Dewey",
  "La mente no es un vaso por llenar, sino una lámpara por encender. - Plutarco",
  "El buen maestro hace que el mal estudiante se convierta en bueno y el buen estudiante en superior. - Marva Collins",
  "La enseñanza es el mayor acto de optimismo. - Colleen Wilcox",
  "Un maestro afecta la eternidad; nunca sabe dónde termina su influencia. - Henry Adams",
  "La educación es el arma más poderosa que puedes usar para cambiar el mundo. - Nelson Mandela",
  "Lo que se les dé a los niños, los niños darán a la sociedad. - Karl Menninger",
  "El principal objetivo de la educación es crear personas capaces de hacer cosas nuevas. - Jean Piaget",
  "Enseñar es aprender dos veces. - Joseph Joubert",
  "No hay espectáculo más hermoso que la mirada de un niño que lee. - Günter Grass"
];

export default function QuoteOfTheDay() {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    
    setQuote(QUOTES[dayOfYear % QUOTES.length]);
  }, []);

  if (!quote) return null;

  const [text, author] = quote.split(' - ');

  return (
    <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-4 flex items-center gap-4 mb-8 shadow-sm">
      <div className="bg-amber-500/10 p-3 rounded-xl text-amber-400 shrink-0">
        <Lightbulb size={24} strokeWidth={2} />
      </div>
      <div>
        <p className="text-slate-300 text-sm font-medium italic leading-relaxed">"{text}"</p>
        <p className="text-slate-500 text-xs font-bold uppercase tracking-wider mt-1.5">{author}</p>
      </div>
    </div>
  );
}
